import React from 'react'
import './InviTrackSum.css'
import './TeamControl.css'

export default function InviTrackSum({total}) {
  return (
    <div className='teamInfo'>
      <div className='teamCountBadge'>
        {total} {total === 1 ? 'invitation':'invitations'}
      </div>
    </div>
  )
}
